import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListOptions from '../FindMyPart/ListOptions';
import useOnclickOutside from 'react-cool-onclickoutside';
import {
  getVariantData,
  getOptions,
  removeUrlParameter,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';

const MiniFindMyPartOptionsGeneral = ({
  baseProductSystemId,
  selectedVariantId,
  initBrandValue = null,
  initModelValue = null,
  initYearValue = null,
}) => {
  const dispatch = useDispatch();
  const brandsRef = useRef();
  const modelsRef = useRef();
  const yearsRef = useRef();
  const checkboxVariantListRef = useRef();
  const variantRef = useOnclickOutside(() => {
    if (checkboxVariantListRef.current) {
      checkboxVariantListRef.current.checked = false;
    }
  });
  const [lastChangedOptionType, setLastChangedOptionType] = useState();
  const [selectedBrand, setSelectedBrand] = useState(initBrandValue);
  const [selectedModel, setSelectedModel] = useState(initModelValue);
  const [selectedYear, setSelectedYear] = useState(initYearValue);
  const [selectedVariantItemName, setSelectedVariantItemName] = useState('');

  const optionsGeneral = useSelector(
    (state) => state.findMyPart.options?.optionsGeneral
  );
  const variantItems = useSelector((state) => state.findMyPart.variantItems);
  const getSelectedOptionsObject = () => {
    const options = {
      baseProductSystemId,
      optionsGeneral: {
        brand: selectedBrand,
        model: selectedModel,
        year: selectedYear,
      },
      optionsPsg: null,
    };
    return options;
  };

  const removeFullPageParam = () => {
    // Only remove this flag if Dropdowns are changed
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('f')) {
      dispatch(removeUrlParameter('f'));
    }
  };

  useEffect(() => {
    if (lastChangedOptionType) {
      removeFullPageParam();
      const options = getSelectedOptionsObject();
      dispatch(getOptions(options, true, false, selectedVariantId));
    }
  }, [selectedBrand, selectedModel, selectedYear]);

  useEffect(() => {
    if (variantItems?.length > 0) {
      let variantObj = variantItems.find((x) => x.id === selectedVariantId);
      if (!variantObj) {
        variantObj = variantItems[0];
      }
      setSelectedVariantItemName(variantObj.name || '');
    }
  }, [variantItems]);

  useEffect(() => {
    setSelectedBrand(initBrandValue);
  }, [initBrandValue]);
  useEffect(() => {
    setSelectedModel(initModelValue);
  }, [initModelValue]);
  useEffect(() => {
    setSelectedYear(initYearValue);
  }, [initYearValue]);

  const showVariantData = () => {
    const options = getSelectedOptionsObject();
    dispatch(getVariantData(options));
  };

  return (
    <Fragment>
      {optionsGeneral && (
        <div className="row find-my-part__options-container">
          {optionsGeneral.brands && (
            <div className="find-my-part__option small-12 columns">
              <ListOptions
                id="fmpBrand"
                title={translate('findmypart.brand')}
                selectRef={brandsRef}
                selectedOption={selectedBrand}
                initVal={selectedBrand}
                list={optionsGeneral.brands}
                setSelectedOption={(val) => {
                  setSelectedModel({});
                  setSelectedYear({});
                  setSelectedBrand(val);
                  setLastChangedOptionType('brand');
                }}
                defaultText={translate('findmypart.selectbrand')}
              />
            </div>
          )}
          {optionsGeneral.models && (
            <div className="find-my-part__option small-12 columns">
              <ListOptions
                id="fmpModels"
                title={translate('findmypart.model')}
                selectRef={modelsRef}
                selectedOption={selectedModel}
                initVal={selectedModel}
                list={optionsGeneral.models}
                setSelectedOption={(val) => {
                  setSelectedYear({});
                  setSelectedModel(val);
                  setLastChangedOptionType('model');
                }}
                defaultText={translate('findmypart.selectmodel')}
              />
            </div>
          )}
          {optionsGeneral.years && (
            <div
              className="find-my-part__option small-12 columns"
              ref={yearsRef}
            >
              <ListOptions
                id="fmpYear"
                title={translate('findmypart.year')}
                selectRef={yearsRef}
                selectedOption={selectedYear}
                initVal={selectedYear}
                list={optionsGeneral.years}
                setSelectedOption={(val) => {
                  setSelectedYear(val);
                  setLastChangedOptionType('year');
                }}
                defaultText={translate('findmypart.selectyear')}
              />
            </div>
          )}
          {variantItems?.length > 1 && (
            <div
              className="find-my-part__option small-12 columns"
              ref={variantRef}
            >
              <h3
                className="product-info__variants-header"
                htmlFor="ProdPageVariantList"
              >
                {translate('findmypart.selectvariant')}
              </h3>
              <section className="product-info__variants">
                <label
                  id="prodPageVariantSelectListLabelId"
                  htmlFor="ProdPageVariantList"
                  className="small"
                >
                  {variantItems?.length > 1 && !selectedVariantItemName ? (
                    <Fragment>{translate('findmypart.selectvariant')}</Fragment>
                  ) : (
                    <Fragment>
                      {selectedVariantItemName || variantItems[0]?.name}
                    </Fragment>
                  )}
                </label>
                <input
                  type="checkbox"
                  id="ProdPageVariantList"
                  className="hides product-info__variants-toggler"
                  ref={checkboxVariantListRef}
                />
                <ul className="product-info__variants-list">
                  {variantItems.map((variant, variantIndex) => (
                    <li
                      key={`variantKey${variantIndex}`}
                      className="product-info__variants-item"
                      data-variants-item-id={variant.id}
                    >
                      <a href={variant.url}>{variant.name}</a>
                    </li>
                  ))}
                </ul>
              </section>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default MiniFindMyPartOptionsGeneral;
